// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const huntail: PokeData = {
  "id": 367,
  "name": "huntail",
  "height": 17,
  "weight": 270,
  "base_experience": 170,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "bite",
    "water-gun",
    "hydro-pump",
    "screech",
    "scary-face",
    "feint-attack",
    "baton-pass",
    "rain-dance",
    "crunch",
    "whirlpool",
    "dive",
    "iron-defense",
    "water-pulse",
    "brine",
    "sucker-punch",
    "aqua-tail",
    "ice-fang",
    "coil",
    "shell-smash"
  ],
  "moves": [
    "bite",
    "hydro-pump",
    "scary-face",
    "rain-dance",
    "crunch",
    "whirlpool",
    "brine",
    "aqua-tail",
    "ice-fang",
    "aqua-cutter",
    "aqua-jet",
    "life-dew",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 188,
    "item": null,
    "species": [
      {
        "name": "clamperl",
        "order": 396,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "huntail",
        "order": 397,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gorebyss",
        "order": 398,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 91,
    "ability_power": 182
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
